function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", {
  id: "CategoryMenuFavouriteUnselected"
}, "CategoryMenu Favourite Unselected");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 2.48771L6.56665 5.5126C6.36416 5.93993 5.97507 6.23633 5.5249 6.30621L2.33829 6.80083L4.63904 9.16494C4.96406 9.49892 5.11268 9.97851 5.03695 10.449L4.50087 13.7796L7.35617 12.2158C7.75954 11.9949 8.24047 11.9949 8.64384 12.2158L11.4991 13.7796L10.9631 10.449C10.8873 9.97852 11.0359 9.49892 11.361 9.16494L13.6617 6.80083L10.4751 6.30621C10.0249 6.23633 9.63585 5.93992 9.43336 5.5126L8 2.48771ZM8.35583 0.897907C8.20973 0.589593 7.79028 0.589593 7.64418 0.897907L5.67708 5.04917C5.61923 5.17126 5.50806 5.25595 5.37944 5.27591L1.00624 5.95472C0.681444 6.00514 0.551825 6.42343 0.78633 6.66439L3.9438 9.90882C4.03666 10.0042 4.07912 10.1413 4.05749 10.2757L3.3218 14.8465C3.26716 15.186 3.60651 15.4445 3.89753 15.2851L7.81605 13.139C7.9313 13.0759 8.06871 13.0759 8.18396 13.139L12.1025 15.2851C12.3935 15.4445 12.7329 15.186 12.6782 14.8465L11.9425 10.2757C11.9209 10.1413 11.9633 10.0042 12.0562 9.90882L15.2137 6.66439C15.4482 6.42343 15.3186 6.00514 14.9938 5.95472L10.6206 5.27591C10.4919 5.25595 10.3808 5.17126 10.3229 5.04917L8.35583 0.897907Z",
  fill: "#1C1C1C"
});

function SvgCategoryMenuFavouriteUnselected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryMenuFavouriteUnselected);
export default __webpack_public_path__ + "static/media/CategoryMenuFavouriteUnselected.3aab32867064a40769026cde5ec07623.svg";
export { ForwardRef as ReactComponent };